import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
const faqs = [{
  q: '¿Sirve si estoy empezando como terapeuta de Chi Kung?',
  a: 'Especialmente si estás empezando. El sistema te da la estructura clínica desde el primer paciente: no necesitas improvisar ni esperar años de experiencia. El Tomo I es tu base operativa, el Tomo II tu biblioteca de sesiones y el Tomo III tu planificación anual.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibes un correo con el acceso a tu descarga. En menos de 5 minutos tienes todo el Mega Pack disponible.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Está optimizado para usarse en tablet u ordenador durante la consulta. Si prefieres imprimirlo, también está diseñado para eso.'
}, {
  q: '¿Qué lo diferencia de un curso de Chi Kung?',
  a: 'Un curso enseña técnica. Este pack te entrega el sistema operativo completo para aplicar lo que ya sabes con criterio clínico, planificación profesional y protección energética real.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí: 7 días, sin preguntas y sin formularios. Si no es lo que esperabas, se te devuelve el 100% del importe.'
}, {
  q: '¿Puedo compartirlo con otros terapeutas?',
  a: 'El pack es de uso personal y profesional exclusivo. No está autorizada su reproducción ni su distribución.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-56" data-mp="rzucnmpiedsz">
      <SectionHeading eyebrow="Preguntas frecuentes" className="mb-12" data-id="element-57" data-mp="s0m6arzjq1gm">
        Lo que más nos preguntan
      </SectionHeading>

      <div className="glass-panel rounded-sm divide-y divide-brand-purpleDark/10" data-id="element-58" data-mp="wvtae0wq9862">
        {faqs.map((faq, i) => <div key={faq.q} data-id="element-59" data-mp="mzq6apibezgh" data-mpi={i}>
            <button type="button" aria-expanded={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 md:px-7 py-5 text-left flex justify-between items-center gap-6 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold hover:bg-brand-surfaceLight/40 transition-colors duration-150 ease-out" data-id="element-60" data-mp="mywwffo27tu4">
              <span className="font-display font-semibold text-base md:text-lg text-brand-purpleDark" data-id="element-61" data-mp="2azk6jnoffjbr">
                {faq.q}
              </span>
              <PlusIcon className={`w-4 h-4 text-brand-goldDark transition-transform duration-200 ease-out shrink-0 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-62" data-mp="33mo6he8nx7go" />
            </button>
            <AnimatePresence initial={false} data-id="element-63" data-mp="2ul6p7sjiqzqe">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-64" data-mp="1n8xy3vaifx18">
                  <p className="px-5 md:px-7 pb-6 text-brand-text/85 text-sm md:text-base leading-relaxed max-w-2xl" data-id="element-65" data-mp="2o1aibxf87lj">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};